import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Input class={{concat \"input l-fill input-percent \" this._isInvalid this.inputClassNames}} placeholder={{this.placeholder}} disabled={{this.disabled}} />", {
  moduleName: "@dashboard/shared-ui/components/sq-input-percent.hbs"
});